import { Passenger } from "../../types/flights";

export const EDPassportDetails: React.FC<{
  passport: Passenger | undefined;
}> = (props) => {
  return (
    <>
      <div className="passport-details-container">
        <div key={`passport`} className="row">
          <div className="col-lg-2"></div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6">
            <div className="passenger-sub-item">
              <span className="passenger-sub-item-heading">Passport No:</span>
              <span>{props.passport?.passportNumber}</span>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6">
            <div className="passenger-sub-item">
              <span className="passenger-sub-item-heading">
                Passport Expiry:
              </span>
              <span>{props.passport?.passportExpiry}</span>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="passenger-sub-item">
              <span className="passenger-sub-item-heading">
                Passport Country:
              </span>
              <span>{props.passport?.passportCountry}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
